
/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Spin, Button } from 'antd';
import { connect } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import localStorage from '../../utils/localStorage';
import {
  API_DEVICE,
  API_MASTERCONFIGURATION,
  API_HMI, MASTERIMAGES
} from '../../commons/api';
import Text from './Text';

const SinglePlot = (props) => {
  const hookParams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    triggerPoint: null,
    config: {},
    annotations: [],
    shapesannotations: [],
    staticannotations: [],
    animations: [],
    sldName: '',
    hmiName: '',
    hmiType: '',
    x: 0,
    y: 0,
    payload: 0,
    initialRender: true,
    deviceList: [],
    loading: true,
    HMITypeList: [],
    lastUpdatedTimeStamp: null,
  });
  const hmiTypeListRef = useRef(state.HMITypeList);

  useEffect(() => {
    hmiTypeListRef.current = state.HMITypeList; // Update ref on state change
  }, [state.HMITypeList]);

  let timeTicket = useRef(null);
  const params = Object.keys(hookParams).length && hookParams.hmiName ? hookParams : (props.match ? props.match.params : {});

  const getHMITypeAPIs = () => {
    setState(prev => ({ ...prev, loading: true }));
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const hmiMappingObject = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { MasterCode: 'HMI_Types', ActionType: 'read', Type: 'WithoutSiteId' }
    };
    return axios(hmiMappingObject)
      .then((response) => {
        setState(prev => ({
          ...prev,
          HMITypeList: response.data || {},
          loading: false
        }));
        return response.data;
      });
  };

  const _updatehmiMapping = (payload, URL) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const hmiMappingObject = {
      method: 'POST',
      url: `${URL}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(hmiMappingObject)
      .then((response) => {
        setState(prev => ({
          ...prev,
          lastUpdatedTimeStamp: moment().format('YYYY-MM-DD HH:mm:ss'),
          annotations: response.data.annotations,
          shapesannotations: response.data.shapesannotations,
          animations: response.data.animations,
          staticannotations: response.data.staticannotations
        }));
      })
      .catch(function () { });
  };

  const _getDeviceList = () => {
    setState(prev => ({ ...prev, loading: true }));
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const devicePayload = {
      method: 'GET',
      url: `${API_DEVICE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(devicePayload)
      .then((response) => {
        setState(prev => ({
          ...prev,
          deviceList: response.data || [],
          loading: false
        }));
      })
      .catch(function () { });
  };

  const hmiMapping = (payload) => {
    setState(prev => ({ ...prev, loading: true }));
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const hmiMappingObject = {
      method: 'GET',
      url: `${API_HMI.GET}?SiteId=${siteId}&Name=${payload.hmiName}&Type=${payload.hmiType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(hmiMappingObject)
      .then(async (response) => {
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          let HMIObject = response.data;
          let data = HMIObject && HMIObject[0] && HMIObject[0].JSON ? HMIObject[0].JSON : {};
          if (timeTicket.current) {
            clearInterval(timeTicket.current);
          }
          const HMITypeList = hmiTypeListRef.current;
          const currentHMI = HMITypeList?.filter(hmi => hmi.HMIType === payload.hmiType);
          const URL = currentHMI?.[0]?.URL || '';
          
          _updatehmiMapping(payload, URL);
          timeTicket.current = setInterval(
            () => {
              _updatehmiMapping(payload, URL);
            },
            data && data.frequency ? data.frequency * 60000 : 1 * 60000
          ); // min frequency

          setState(prev => ({
            ...prev,
            loading: false,
            config: data
          }));
        }
      })
      .catch(function () { });
  };

  useEffect(() => {
    let hmiObj;
    if (params.hmiName && params.type) {
      setState(prev => ({
        ...prev,
        hmiName: params.hmiName,
        hmiType: params.type || 'dynamic',
        code: params.dynamicName
      }));
      hmiObj = {
        hmiName: params.hmiName,
        hmiType: params.type || 'dynamic',
        code: params.dynamicName
      };
      _getDeviceList();
    } else if (params.hmiName && !params.dynamicName) {
      setState(prev => ({
        ...prev,
        hmiName: params.hmiName,
        hmiType: 'static',
        sldName: params.hmiName
      }));
      hmiObj = {
        hmiName: params.hmiName,
        hmiType: 'static'
      };
      setState(prev => ({
        ...prev,
        sldName: params.hmiName
      }));
    }
    if (hmiObj) {
      getHMITypeAPIs().then(() => {
        hmiMapping(hmiObj);
      });
    } else {
      getHMITypeAPIs();
    }
    return () => {
      if (timeTicket.current) {
        clearInterval(timeTicket.current);
      }
    };
  }, []);

  useEffect(() => {
    let { initialRender, hmiName, code } = state;
    const siteId = localStorage.get('currentSite');
    try {
      if (
        params.hmiName &&
        params.type &&
        (params.hmiName !== hmiName ||
          params.dynamicName !== code ||
          initialRender)
      ) {
        setState(prev => ({
          ...prev,
          hmiName: params.hmiName,
          hmiType: params.type,
          code: params.dynamicName
        }));
        let hmiObj = {
          hmiName: params.hmiName,
          hmiType: params.type,
          code: params.dynamicName
        };
        hmiMapping(hmiObj);
        setState(prev => ({
          ...prev,
          initialRender: false
        }));
      } else if (
        params.hmiName !== hmiName ||
        (initialRender && params.hmiName && !params.dynamicName)
      ) {
        setState(prev => ({
          ...prev,
          hmiName: params.hmiName,
          hmiType: params.type
        }));
        let hmiObj = {
          hmiName: params.hmiName,
          hmiType: params.type,
          SiteId: siteId
        };
        setState(prev => ({
          ...prev,
          initialRender: false
        }));
        hmiMapping(hmiObj);
      }
    } catch (e) {
      console.warn("error faced", e);
    }
  }, [params.hmiName, params.type, params.dynamicName, state.initialRender]);

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };

  return (
    <div>
      {state.loading === false ? (
        <div>
          {state.config.showGoBack && location.pathname.split('/rubus/HMI').length > 1 && (
            <Button
              type="primary"
              shape="round"
              style={{ marginLeft: '10px' }}
              onClick={() => navigate(-1)}
            >
              <LeftOutlined />
              Go back
            </Button>
          )}
          {/* {hmiType &&
            (hmiType === 'dynamic' || hmiType === 'distinct') &&
            props.triggerPoint !== 'dashboard' ? (
              <SelectComponent
                hmiName={hmiName}
                hmiType={hmiType}
                code={code}
                deviceList={deviceList}
                api={config && config.api ? config.api : {}}
              />
            ) : null} */}
          <svg viewBox={state.config.viewbox}>
            <image href={`${state.config.Url}`} width={state.config.width} height={state.config.height} />
            {state.shapesannotations && state.shapesannotations.length > 0
              ? state.shapesannotations
                .filter((ann) => ann.ignore !== true)
                .map((annotations) => {
                  switch (annotations.type) {
                    case 'rect':
                      return (
                        <rect
                          x={annotations.x}
                          y={annotations.y}
                          rx={annotations.rx}
                          ry={annotations.ry}
                          width={annotations.width}
                          height={annotations.height}
                          fill={annotations.fill}
                          className={annotations.className}
                          fillOpacity={annotations.opacity}
                          onClick={
                            annotations.route === true
                              ? () => {
                                props.navigate(annotations.path);
                              }
                              : undefined
                          }
                        />
                      );
                    case 'circle':
                      return (
                        <circle
                          cx={annotations.cx}
                          cy={annotations.cy}
                          r={annotations.r}
                          fill={annotations.fill}
                          className={annotations.className}
                          fillOpacity={annotations.opacity}
                        />
                      );
                    case 'ellipse':
                      return (
                        <ellipse
                          cx={annotations.cx}
                          cy={annotations.cy}
                          rx={annotations.rx}
                          ry={annotations.ry}
                          fill={annotations.fill}
                          className={annotations.className}
                          fillOpacity={annotations.opacity}
                        />
                      );
                    case 'recthref':
                      return (
                        <Link to={annotations.link}>
                          <rect
                            x={annotations.x}
                            y={annotations.y}
                            width={annotations.width}
                            height={annotations.height}
                            fill={'transparent'}
                            fill-opacity={annotations.opacity}
                          />
                        </Link>
                      );
                    // rectwithtext is to align text at the center of rectangle
                    case 'rectwithtext':
                      return (
                        <svg>
                          <text
                            x="37.3"
                            y="7"
                            alignment-baseline="middle"
                            text-anchor="middle"
                            fontSize="1px"
                            fontWeight="bold"
                          >
                            {translation('MAGOME FACTORY')}
                          </text>
                        </svg>
                      );
                    // string is used to translate a text to other languages
                    case 'string':
                      return (
                        <Text
                          type={annotations.type}
                          limits={annotations.limits}
                          x={annotations.x}
                          y={annotations.y}
                          fontFamily={state.config.fontFamily}
                          fontSize={state.config.fontSize}
                          fill={annotations.colorCode}
                          checkStatus={state.config.checkStatus}
                          displayName={annotations.displayName}
                          device={annotations.device}
                          conditions={annotations.conditions}
                          payload={annotations.payload}
                          fontWeight={annotations.fontWeight}
                          hmiName={state.hmiName}
                          hmiType={state.hmiType}
                        />
                      );
                    default:
                      return null;
                  }
                })
              : ''}

            {state.annotations && state.annotations.length > 0
              ? state.annotations
                .filter((ann) => ann.ignore !== true)
                .map((annotation, index) => {
                  return (
                    <Text
                      key={index}
                      limits={annotation.limits}
                      x={annotation.x}
                      y={annotation.y}
                      fontFamily={
                        annotation.fontFamily && annotation.fontFamily !== undefined
                          ? annotation.fontFamily
                          : state.config.fontFamily
                      }
                      fontSize={
                        annotation.fontSize && annotation.fontSize !== undefined
                          ? annotation.fontSize
                          : state.config.fontSize
                      }
                      fill={
                        annotation.fill && annotation.fill !== undefined
                          ? annotation.fill
                          : state.config.fill
                      }
                      type={
                        annotation.type && annotation.type !== undefined
                          ? annotation.type
                          : 'number'
                      }
                      className={annotation.className}
                      checkStatus={state.config.checkStatus}
                      displayParameters={state.config.displayParameters}
                      displayName={annotation.displayName}
                      device={annotation.device}
                      conditions={annotation.conditions}
                      payload={annotation.payload}
                      fontWeight={annotation.fontWeight}
                      alignment={annotation.alignment}
                      hmiName={state.hmiName}
                      hmiType={state.hmiType}
                      annotation={annotation}
                    />
                  );
                })
              : ''}

            {state.animations && state.animations.length > 0
              ? state.animations
                .filter((ann) => ann.ignore !== true)
                .map((animation) => {
                  switch (animation.type) {
                    case 'fan':
                      return (
                        <image
                          x={animation.x}
                          y={animation.y}
                          xlinkHref={`${MASTERIMAGES.MasterImages}/${animation.imagePrefix}${animation.payload}${animation.imageFormat}`}
                          className={`rotate_${animation.payload}`}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '4px'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4px'
                          }
                        />
                      );
                    case 'pointer':
                      return (
                        <image
                          x={animation.x}
                          y={animation.y}
                          xlinkHref={`${MASTERIMAGES.MasterImages}/${animation.imagePrefix}${animation.payload}${animation.imageFormat}`}
                          className={`rotate_${animation.payload}`}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '4px'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4px'
                          }
                        />
                      );
                    case 'arrow':
                      return (
                        <image
                          x={animation.x}
                          y={animation.y}
                          xlinkHref={`${MASTERIMAGES.MasterImages}/${animation.imagePrefix}${animation.payload}${animation.imageFormat}`}
                          className={`arrow_${animation.payload}`}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '4px'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4px'
                          }
                        />
                      );
                    case 'foreignLR':
                      return (
                        <foreignObject
                          className="node"
                          x={animation.x}
                          y={animation.y}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '18'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4'
                          }
                        >
                          <div
                            style={{ width: '20px', height: '10px' }}
                            className={` sideLR_${animation.payload} normal`}
                          >
                            {' '}
                          </div>
                        </foreignObject>
                      );
                    case 'foreignTB':
                      return (
                        <foreignObject
                          className="node"
                          x={animation.x}
                          y={animation.y}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '1'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '11'
                          }
                        >
                          <div
                            style={{ width: '4px', height: '7px' }}
                            className={` topTB_${animation.payload} normal`}
                          >
                            {' '}
                          </div>
                        </foreignObject>
                      );
                    case 'foreignRL':
                      return (
                        <foreignObject
                          className="node"
                          x={animation.x}
                          y={animation.y}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '18'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4'
                          }
                        >
                          <div
                            style={{ width: '20px', height: '10px' }}
                            className={` sideRL_${animation.payload} normal`}
                          >
                            {' '}
                          </div>
                        </foreignObject>
                      );
                    case 'foreignBT':
                      return (
                        <foreignObject
                          className="node"
                          x={animation.x}
                          y={animation.y}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '1'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '11'
                          }
                        >
                          <div
                            style={{ width: '4px', height: '7px' }}
                            className={` topBT_${animation.payload} normal`}
                          >
                            {' '}
                          </div>
                        </foreignObject>
                      );
                    case 'image':
                      return (
                        <image
                          x={animation.x}
                          y={animation.y}
                          onError={(event) => (event.target.style.display = 'none')}
                          xlinkHref={`${MASTERIMAGES.MasterImages}/${animation.imagePrefix}${animation.payload}${animation.imageFormat}`}
                          className={animation.className}
                          width={
                            animation.width && animation.width !== undefined
                              ? animation.width
                              : '4px'
                          }
                          height={
                            animation.height && animation.height !== undefined
                              ? animation.height
                              : '4px'
                          }
                        />
                      );
                    default:
                      return {};
                  }
                })
              : ''}

            {state.staticannotations && state.staticannotations.length > 0
              ? state.staticannotations
                .filter((ann) => ann.ignore !== true)
                .map((annotation, index) => {
                  return (
                    <Text
                      key={index}
                      limits={annotation.limits}
                      x={annotation.x}
                      y={annotation.y}
                      fontFamily={
                        annotation.fontFamily && annotation.fontFamily !== undefined
                          ? annotation.fontFamily
                          : state.config.fontFamily
                      }
                      fontSize={
                        annotation.fontSize && annotation.fontSize !== undefined
                          ? annotation.fontSize
                          : state.config.fontSize
                      }
                      fill={
                        annotation.fill && annotation.fill !== undefined
                          ? annotation.fill
                          : state.config.fill
                      }
                      type={
                        annotation.type && annotation.type !== undefined
                          ? annotation.type
                          : 'number'
                      }
                      className={annotation.className}
                      checkStatus={state.config.checkStatus}
                      displayParameters={state.config.displayParameters}
                      displayName={annotation.displayName}
                      device={annotation.device}
                      conditions={annotation.conditions}
                      payload={state[annotation.mappingKey]}
                      fontWeight={annotation.fontWeight}
                      alignment={annotation.alignment}
                      hmiName={state.hmiName}
                      hmiType={state.hmiType}
                      annotation={annotation}
                    />
                  );
                })
              : ''}
          </svg>
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '20%' }}>
          <Spin spinning={state.loading} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

const withRouter = (WrappedComponent) => {
  const EnhancedComponent = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const combinedProps = {
      ...props,
      navigate,
      location
    };

    return <WrappedComponent {...combinedProps} />;
  };

  EnhancedComponent.displayName = `WithRouterAndRedux(${WrappedComponent.displayName || WrappedComponent.name
    })`;

  return EnhancedComponent;
};

export default connect(mapStateToProps)(withRouter(SinglePlot));